import { isNotDefined } from "../utils";
import { Alligator as defaultOptions } from "./defaultOptionsForComputation";
import offsetSeries from "./offsetSeries";

export default function () {
  let options = defaultOptions;

  // SMMA (Smoothed Moving Average / Welles Wilder) calculator
  function calculateSMMA(data, source, period) {
    const alpha = 1 / period; // Welles Wilder uses alpha = 1/period
    let previous;
    let initialAccumulator = 0;
    let skip = 0;

    return data.map(function (d, i) {
      const v = source(d, i);
      if (isNotDefined(previous) && isNotDefined(v)) {
        skip++;
        return undefined;
      } else if (i < period + skip - 1) {
        initialAccumulator += v;
        return undefined;
      } else if (i === period + skip - 1) {
        initialAccumulator += v;
        const initialValue = initialAccumulator / period;
        previous = initialValue;
        return initialValue;
      } else {
        const nextValue = v * alpha + (1 - alpha) * previous;
        previous = nextValue;
        return nextValue;
      }
    });
  }

  function calculator(data) {
    const {
      jawPeriod,
      jawOffset,
      teethPeriod,
      teethOffset,
      lipsPeriod,
      lipsOffset,
    } = options;

    // Source is always HL/2 (median price)
    const source = (d) => {
      if (!d || d.high == null || d.low == null) return undefined;
      return (d.high + d.low) / 2;
    };

    // Calculate SMMA for each line
    const jawValues = calculateSMMA(data, source, jawPeriod);
    const teethValues = calculateSMMA(data, source, teethPeriod);
    const lipsValues = calculateSMMA(data, source, lipsPeriod);

    // Deslocamento no tempo (REF do engine) — operador único, ver offsetSeries.
    const jawShifted = offsetSeries(jawValues, jawOffset);
    const teethShifted = offsetSeries(teethValues, teethOffset);
    const lipsShifted = offsetSeries(lipsValues, lipsOffset);

    // Combine into result
    return data.map((d, i) => ({
      jaw: jawShifted[i],
      teeth: teethShifted[i],
      lips: lipsShifted[i],
    }));
  }

  calculator.undefinedLength = function () {
    // Maximum period needed to start calculating
    const { jawPeriod } = options;
    return jawPeriod - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) return options;
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
